import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomisableSection } from '@shared/models/customisable-section';
import { replaceTemplateKeys } from '@shared/utils/url.lib';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiEndpoint } from '../enums/api-endpoints.enum';

@Injectable({ providedIn: 'root' })
export class CustomisableSectionsService {
  constructor(private http: HttpClient) {}

  public getCustomisableSections(ids: string[]): Observable<CustomisableSection[]> {
    const requests = ids.map((id) => this.getCustomisableSection(id));
    return forkJoin(requests);
  }

  public getCustomisableSection(id: string): Observable<CustomisableSection> {
    const url = replaceTemplateKeys(ApiEndpoint.CUSTOMISABLE_SECTIONS, { id });

    return this.http.get<CustomisableSection>(url).pipe(catchError(() => of(null)));
  }
}
